import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type PushNotification} from './types';

const domain = 'NOTIFICATIONS';
export const {action: didReceiveDeviceToken} = createAction(
    `${domain}/DID_RECEIVE_DEVICE_TOKEN`,
    (deviceToken: string) => ({
        deviceToken,
    }),
);

export const {action: didReceiveNotification} = createAction(
    `${domain}/DID_RECEIVE_NOTIFICATION`,
    ({notification, foreground}: {notification: PushNotification; foreground: boolean}) => ({
        notification,
        foreground,
    }),
);
